import { render, staticRenderFns } from "./SummaryLine.vue?vue&type=template&id=5b728539&scoped=true&"
import script from "./SummaryLine.vue?vue&type=script&lang=js&"
export * from "./SummaryLine.vue?vue&type=script&lang=js&"
import style0 from "./SummaryLine.vue?vue&type=style&index=0&id=5b728539&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b728539",
  null
  
)

export default component.exports